<template>
    <div id="summary-income-source" class="vx-col w-full mb-base">
        <div class="vx-col w-full mb-5">
            <div class="vx-row same-h mb-base">
                <vx-card class="mb-4 ml-4 mr-4">
                    <div class="vx-col w-full">
                        <h2 class="text-primary bold">Resumen de ingresos de solicitante</h2>
                        <p class="mb-0">Corresponde a la información  de ocupación, empleo y gastos del solicitante.</p>
                    </div>
                </vx-card>
                <!-- INFO OCUPACIÓN -->
                <div class="vx-col sm:w-full md:w-1/2 lg:w-1/2">
                    <vx-card>
                        <h5>
                            <feather-icon
                                icon="BriefcaseIcon"
                                svgClasses="w-5 h-5 text-primary"
                                class="mr-2" />
                            Ocupación del solicitante
                        </h5>
                        <ul class="black ul-list mb-5">
                            <li><span class="bold">Ocupación: </span>{{ personal.occupation.name }}</li>
                            <li><span class="bold">Sector: </span>{{ personal.personal_business_activity.sector_name }}</li>
                            <li><span class="bold">Actividad principal: </span>{{ personal.personal_business_activity.name }}</li>
                        </ul>
                        <h5>
                            <feather-icon
                                icon="BoxIcon"
                                svgClasses="w-5 h-5 text-primary"
                                class="mr-2" />
                            {{ getEmploymentTitle }}
                        </h5>
                        <ul class="black ul-list">
                            <li><span class="bold">Nombre de la empresa o negocio: </span>{{ mainIncomeSource.employer }}</li>
                            <li><span class="bold">Antigüedad: </span>{{ mainIncomeSource.senority }} año(s)</li>
                            <li v-if="!isRetired"><span class="bold">Teléfono: </span>{{ mainIncomeSource.phone != null ? phoneFormatDialCode(mainIncomeSource.phone.country_calling_code + mainIncomeSource.phone.phone) : "--" }}</li>
                            <li><span class="bold">Tiene afiliación con IMSS: </span>{{ personal_credit_profile.social_security_affiliated == 1 ? "Si" : "No" }}</li>
                        </ul>
                    </vx-card>
                </div>
                <!-- INFO GASTOS -->
                <div class="vx-col sm:w-full md:w-1/2 lg:w-1/2 same-h">
                    <vx-card>
                        <h5>
                            <feather-icon
                                icon="DollarSignIcon"
                                svgClasses="w-5 h-5 text-primary"
                                class="mr-2" />
                            Ingresos mensuales
                        </h5>
                        <ul class="black ul-list mb-4">
                            <!-- {{ personal_credit_profile.monthly_incomes }} -->
                            <li><span class="bold">Ingresos principales: </span>{{ costFormatNoCents(monthly_incomes.main) }}</li>
                            <li><span class="bold">Otros: </span>{{ costFormatNoCents(monthly_incomes.other) }}</li>
                        </ul>
                        <h5>
                            <feather-icon
                                icon="DollarSignIcon"
                                svgClasses="w-5 h-5 text-primary"
                                class="mr-2" />
                            Gastos mensuales</h5>
                        <ul class="black ul-list">
                            <li><span class="bold">Alimentos, salud y ropa: </span>{{ costFormatNoCents(monthly_expenses.food) }}</li>
                            <li><span class="bold">Transporte y gasolina: </span>{{ costFormatNoCents(monthly_expenses.transportation) }}</li>
                            <li><span class="bold">Entretenimiento: </span>{{ costFormatNoCents(monthly_expenses.services) }}</li>
                            <li><span class="bold">Seguros: </span>{{ costFormatNoCents(monthly_expenses.ensurance) }}</li>
                        </ul>
                    </vx-card>
                </div>
                <!-- DOCUMENTOS -->
                <div class="vx-col w-full mt-4">
                    <vx-card>
                        <h5 class="mb-4">
                            <feather-icon
                                icon="FileTextIcon"
                                svgClasses="w-5 h-5 text-primary"
                                class="mr-2" />
                            Comprobantes de ingresos
                        </h5>
                        <div class="vx-row">
                            <div v-if="ip.document_file != null" class="vx-col sm:w-1/3 w-full flex" :key="index" v-for="(ip, index) in incomeProofs">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <ul class="black ul-list mb-4">
                                            <li><span class="bold">Tipo de documento: </span>{{ ip.document_type }}</li>
                                            <li><span class="bold">Fecha de carga: </span>{{ dateTimeFormat(ip.document_file.created_at) }}</li>
                                        </ul>
                                    </div>
                                    <div class="vx-col w-full">
                                        <div class="vx-row">
                                            <document-upload
                                                :target_id="project.client.user_id"
                                                :f="{
                                                    field_name: 'Comprobante',
                                                }"
                                                :doc="ip.document_file.document"
                                                :evaluator="evaluateCondition"
                                                :loadedState="ip.document_file"
                                                :disabled="disableEdition"
                                                :stickToLoadedState="true"
                                                @on-success="onDocumentUploadSuccess"
                                                :editableByBackoffice="true"
                                                :from_project_id="project.id"
                                                :withOutClass="true"
                                                :assocIdBypass="ip.id"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vx-card>
                </div>
            </div>
            <vs-divider></vs-divider>
        </div>
    </div>
  </template>
  
<script>
import inputHelper from "@mixins/inputHelper"
import IncomeSourcesEditPage from "@views/admin/projectsv2/IncomeSourcesEditPage";
import formatHelper from "@mixins/formatHelper";
import FormIncomeProofs from "@incomeSources/FormIncomeProofs";
import dateHelper from "@mixins/dateHelper";
import FormField from '@components/forms/FormField.vue';

const indicationDef = "Selecciona una fuente de ingresos para el solicitante.";
const errorMssgDef = "Ha ocurrido un error, intente más tarde.";
const successMssgDef = "El registro ha sido agregado exitosamente";
const roles = ["pf_income_source", "pf_income_source_obligated", "pm_income_source", "pm_income_source_obligated"];

export default {
    name: 'SummaryIncomeSources',
    mixins: [inputHelper, formatHelper, dateHelper],
    props: {
        project: {type: Object, required: true},
        f: { type: Object, required: true },
        p_type: {type: [String, Number], required: true},
        isDisabled: { type: [String,Boolean], default: false },
        role: { type: String, default: "pf_income_source"}
    },
    components: {
        IncomeSourcesEditPage,
        FormIncomeProofs,
        FormField
    },
    data() {
        return {
            showFormPrompt: false
            , onError: false
            , onSuccess: false
            , errorMssg: errorMssgDef
            , successMssg: successMssgDef
            , formPromptIndication: indicationDef
            , getIncomeSourcesForSelect: []
            , selectedIncomeSourceId: null
            , incomeSources: []
            , incomeSourceSelected: {}
            , roles: roles,
            profileId: null

            // BASE INFORMATION
            , personal_profile_id: null
            , incomeSourceValidation: null
            , incomeProofs: {}
        }
    },
    async mounted() {
        this.showLoading(true);
        this.setBaseInformation();
        // await this.getIncomeSources();
        await this.getIncomeSourcesForApplicant();
        await this.getIncomeProofs();
        this.showLoading(false);
    }, 
    computed: {
        getPersonType() {
            switch(this.role) {
                case 'pf_income_source': return this.p_type;
                case 'pf_income_source_obligated': return 1;
                case 'pm_income_source_obligated': return 0;
                case 'pm_income_source': return 0;
            }
        },
        completeForm(){
            return this.selectedIncomeSourceId != null;
        },
        hasBackofficeAccess(){
            return this.$acl.check('isBackoffice');
        },
        current_project_id(){
            return this.project.id;
        },
        personal(){
            return this.project.client.user.personal;
        },
        personal_credit_profile(){
            return this.personal.credit_profile;
        },
        pf_guarantee_personal(){
            return this.personal.guarantee_profile.personal;
        },
        getEmploymentTitle() {
            if(this.personal.occupation.id == 5) {
                return "Información de último empleo";
            } else if(this.personal.occupation.id == 1){
                return "Información de empleo actual";
            } else {
                return "Información de negocio o servicio";
            }
        },
        isRetired() {
            return this.personal.occupation.id == 5;
        },
        mainIncomeSource() {
            return this.incomeSources[0];
        },
        monthly_expenses(){
            return JSON.parse(this.personal_credit_profile.monthly_expenses);
        },
        monthly_incomes(){
            return JSON.parse(this.personal_credit_profile.monthly_incomes);
        },
        pp_income_source_proof_id(){
        return this.incomeProof.id;
        },
    },
    methods: {
        addIncomeSource(){
            this.$router.push({ name: 'editarIncomeSourcesDeSolicitante', params: { id: this.current_project_id, income_source_id: -1, role: this.role } })
        },
        resetForm(){
            this.selectedIncomeSourceId = null
            this.onError = null
            this.onSuccess = null      
        },
        closeFormPrompt() {
            this.showFormPrompt = false;
            this.resetForm();
        },
        async getIncomeSources(){
            if(this.role == 'obligated_missing')
            return;

            try{
            let res = await axios.get(`/api/v1/forms/${this.getPersonType}/getIncomeSources`);
            let sources = res.data;

            let options = [];

            sources.forEach(s => {
                options.push({value: s.id, text: s.name});
            });
            this.getIncomeSourcesForSelect = options;
            } catch (error) {

            }
        },
        hasError(val){
            return this.errors.has(val);
        },
        errorText(val){
            return this.errors.first(val);
        },
        isSuccess(val){
            let ff = this.fields[val];
            return (ff && ff.required && ff.valid);
        },
        async addIncomeSourceToApplicant(){
            this.onSuccess = false;
            this.onError = false;

            this.showLoading(true);
            try {
            const payload = {
                profileId: this.profileId,
                incomeSourceId: this.selectedIncomeSourceId,
                role: this.role
            };
            let res = await axios.post(`/api/v1/forms/createIncomeSource`, payload);
            let new_pp_income_id;

            if(res.data.success != true){
                this.errorMssg = res.data.error;
                this.onError = true;
            }
            else {
                new_pp_income_id = res.data.id;
                this.onSuccess = true;
                this.closeFormPrompt();
        
                // redireccionar a la vista de edicion
                this.$router.push({ name: 'editarIncomeSourcesDeSolicitante', params: { id: this.current_project_id, income_source_id: new_pp_income_id, role:this.role } })
            }
            }
            catch (error) {
            this.warn(error);
            this.onError = true;
            }
            this.showLoading(false);

        },
        async getIncomeSourcesForApplicant(){
            if(this.role == 'obligated_missing')
            return;
            
            try{
            let res = await axios.get(`/api/v1/forms/${this.profileId}/${this.role}/getProfileIncomeSources`);
            this.incomeSources = res.data;

            let resValidations = await axios.get(`/api/v1/income_sources/${this.profileId}/${this.role}/verify`)
            this.incomeSourceValidation = resValidations.data;

            } catch (error) {
            console.log(error);
            }
        },
        editItemRequest(income_sources){
            this.$router.push({ name: 'editarIncomeSourcesDeSolicitante', params: { id: this.current_project_id, income_source_id: income_sources.id, role: this.role } })
        },
        removeItemRequest(income_source){
            this.incomeSourceSelected = income_source;

            this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: 'Descartar registro',
            text: `¿Realmente desea eliminar el registro? Todos los datos registrados para esta fuente de ingresos también serán descartados`,
            acceptText: "Eliminar",
            cancelText: 'Cancelar',
            accept: this.doRemoveItem
            });
        },
        async doRemoveItem(){
            this.showLoading(true);
            try {
            let payload = {income_source_id: this.incomeSourceSelected.id, role: this.role};
            await axios.post('/api/v1/income_sources/delete_income_source', payload);
            this.successNotif("Operación exitosa", "Registro descartado correctamente");
            await this.getIncomeSourcesForApplicant();
            }
            catch (error) {
            this.warn(error);
            }
            this.showLoading(false);
        },
        setBaseInformation(){
            switch(this.role){
            case "pf_income_source":
                this.profileId = this.personal.id;
                break;
            case "pf_income_source_obligated":
                this.profileId = this.project.finance.guarantee.guarantee_profile.personal.id;
                break;
            case "pf_income_source_owner":
                this.profileId = this.project.client.user.business.owner_personal_profile.id;
                break;
            case "pf_income_source_representative":
                this.profileId = this.project.client.user.business.personal.id;
                break;
            case "pm_income_source_obligated":
                this.profileId = this.project.finance.guarantee.guarantee_profile.business.id;
                break;
            case "pm_income_source_owner":
                this.profileId = this.project.client.user.business.owner_business_profile.id;
                break;
            case "pm_income_source":
                this.profileId = this.project.client.user.business.id;
                break;
            default: console.log("NO SE DEFINIÓ");
            }
        },
        getIncomeSourceStatus(id){
            if(!this.incomeSourceValidation){
            return null;
            }
            const validation = this.incomeSourceValidation.validations.find(x => x.income_source_id == id );
            if(!validation.employeeDataValidations || validation.employeeDataValidations.complete){
            let proofsComplete = validation.proofsDataValidations.findIndex(item => item.completeProof == false);
            if(proofsComplete != -1){
                return "Info. de comprobante de ingresos faltante."
            } else {
                return "Info. y documentos completos."
            }
            } else {
            return "Info. de fuente de ingresos faltante.";
            }
        },
        getIncomeSourceStatusClass(id){
            if(!this.incomeSourceValidation){
                return "";
            }
            
            const validation = this.incomeSourceValidation.validations.find(x => x.income_source_id == id )
            if(!validation.employeeDataValidations || validation.employeeDataValidations.complete){
                let proofsComplete = validation.proofsDataValidations.findIndex(item => item.completeProof == false);
                if(proofsComplete != -1){
                return "text-danger";
                }
                return "text-success";
            } else {
                return "text-danger";
        }
        },
        async getIncomeProofs() {
            try {
                let res = await axios.get(`/api/v1/incomeProofs/getProofs/${this.mainIncomeSource.id}/${this.role}`);
                this.incomeProofs = res.data;
            } catch (e) {
                console.log(e);
                this.warn(e);
            }
        },
        async onDocumentUploadSuccess(data){
            this.successMssg = "El documento ha sido cargado correctamente. El comprobante ahora se encuentra en proceso de verificación.";

            await this.$emit('on-account-saved');
        },
        /* evaluator */
        evaluateCondition(condition){
            return this.evaluateConditionBase(this, condition);
        },
    }
};
</script>
  
<style>

.ul-list {
    line-height: 24px;
    list-style: inside;
    margin-left: .5rem;
}

</style>